import get from "lodash/get";
export var selectNext = function (nextStep, getState) {
    var state = getState();
    if (!nextStep || state.invalid)
        return;
    if (typeof nextStep === 'string') {
        return nextStep;
    }
    if (typeof nextStep === 'function') {
        return nextStep(state);
    }
    var selectedValue = get(state.values, nextStep);
    return nextStep.stepMapper[selectedValue];
};
